<template>
  <NuxtLayout name="default">
    <div
      class="mx-auto flex w-full max-w-[1440px] flex-col items-center gap-10 px-6 pb-spacing_17 pt-5 md:gap-[60px] md:px-[150px] md:pt-0"
    >
      <CartTabs
        v-if="userToken"
        class="w-full"
        :selected-id="selectedId"
        :tabs="cartTabs"
        @select="selectCart"
      />

      <Button
        v-if="$route.params.id"
        class="self-start"
        prefix_icon="ic-arrow-left"
        label="Back to Saved Carts"
        :c_style="{
          type: 'tertiary',
        }"
        @click="$router.push(paths.saved_cart)"
      />

      <slot></slot>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import Button from "~/components/common/Atom/Button.vue";
import CartTabs from "~/components/features/Checkout/Molecule/Tabs.vue";
import paths from "~/constants/paths";
import useCart from "~/composables/Checkout/useCart";
import type { IconNamesType } from "~/types/Icons";

type CartTab = {
  id: string;
  label: string;
  count: number;
  prefix_icon?: IconNamesType;
};

const { cart, savedCarts, fetchSavedCarts } = useCart();
const userToken = useCookie("hs-token");
const route = useRoute();
const router = useRouter();
const nuxtApp = useNuxtApp();

const selectedId = computed(() =>
  `${route.path}/${route.params?.id ?? ""}` === `${paths.cart}/`
    ? "ACTIVE_CART"
    : "SAVED_CART",
);

const isSavedCartEnabled = computed(
  () => nuxtApp.$features?.cart?.enable_saved_cart ?? true,
);

const cartTabs = computed<CartTab[]>(() => {
  const tabs: CartTab[] = [
    {
      id: "ACTIVE_CART",
      prefix_icon: "ic-cart",
      label: "Active Cart",
      count: cart.value?.total_quantity ?? 0,
    },
  ];

  if (isSavedCartEnabled.value) {
    tabs.push({
      id: "SAVED_CART",
      prefix_icon: "ic-favorite",
      label: "Saved Cart",
      count: savedCarts.value?.length ?? 0,
    });
  }

  return tabs;
});

const selectCart = (id: string) => {
  router.push(id === "ACTIVE_CART" ? paths.cart : paths.saved_cart);
};

if (isSavedCartEnabled.value) fetchSavedCarts();
</script>

<style>
.cart-template {
  .cart-main-container {
    @apply gap-5;
  }

  .cart-list {
    @apply md:w-[520px];
  }
}
</style>
